const categories = [
  "Proof of Bond",
  "Proof of Broker Authority",
  "Driver's License / ID of Owner",
  "Other"
];

export default categories;
